import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';
import { applyColor } from '~src/style/ColorService';

import { LoadingPoolsSpinner } from '../../bridgeMultiPool/LoadingPoolsSpinner';
import { RoutingFilterItem } from '../../types/RoutingFilterItem';
import { RoutingFilterTableBody } from './RoutingFilterTableBody';
import { RoutingFilterTableHeader } from './RoutingFilterTableHeader';

export type RoutingFilterTableProps = Readonly<{
  filters: ReadonlyArray<RoutingFilterItem>;
  isLoading: boolean;
}>;

export function RoutingFilterTable(props: RoutingFilterTableProps) {
  const { filters, isLoading } = props;

  if (isLoading) {
    return (
      <table className={tableClass}>
        <RoutingFilterTableHeader />
        <LoadingPoolsSpinner />
      </table>
    );
  }

  if (filters.length === 0) {
    return (
      <>
        <table className={tableClass}>
          <RoutingFilterTableHeader />
        </table>
        <div className={noFiltersClass}>{Messages.bridgeSiteSettingsNoRoutingFiltersSpecified()}</div>
      </>
    );
  }

  return (
    <table className={tableClass}>
      <RoutingFilterTableHeader />
      <RoutingFilterTableBody filters={filters} />
    </table>
  );
}

const tableClass = cssClass('routing-filter-table', 'root', {
  width: '100%',
  borderCollapse: 'collapse',
  textAlign: 'left',
  backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, TabStyles.Colors.White),
  cursor: 'default'
});

const noFiltersClass = cssClass('routing-filter-table', 'no-filters-specified', {
  textAlign: 'center',
  paddingTop: TabStyles.Spacing.DefaultSpace
});
